// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mu_FSwCnUoOLLU {
  position: relative;
  max-width: 240px;
  padding: 8px 12px;
  overflow: hidden;
}
.Mu_FSwCnUoOLLU h3 {
  font-size: 14px;
}
.Mu_FSwCnUoOLLU p {
  margin-bottom: 12px;
}
.Mu_FSwCnUoOLLU .D2PTBkascRlu69 {
  margin-right: 32px;
  margin-bottom: 4px;
}
.Mu_FSwCnUoOLLU .D2PTBkascRlu69 a {
  color: var(--ds-text-subtle, #44546f);
  text-decoration: underline;
}
.Mu_FSwCnUoOLLU .D2PTBkascRlu69 a:hover {
  color: var(--ds-text, #172b4d);
}
.Mu_FSwCnUoOLLU .qHv1aoyRoHslJo {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 24px;
  height: 24px;
  border-radius: var(--ds-border-radius-050, 2px);
  background: var(--ds-background-accent-purple-bolder, #5e4db2);
}
.Mu_FSwCnUoOLLU .m9nKPuYKbooLkJ {
  position: absolute;
  z-index: 1;
  right: -28px;
  bottom: -64px;
  width: 120px;
  height: 80px;
  transform: rotate(-50deg);
  border-radius: 12px;
  background: var(--ds-background-neutral, #091e420f);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContent": `Mu_FSwCnUoOLLU`,
	"ctaContainer": `D2PTBkascRlu69`,
	"iconContainer": `qHv1aoyRoHslJo`,
	"iconBackground": `m9nKPuYKbooLkJ`
};
export default ___CSS_LOADER_EXPORT___;
